import React  from 'react'
import { en } from './languages'

export const EmptyList = ({type}) => (
  <div className="emptyList">{en.please_add}{type}</div>
)